import React from 'react';
import { createRoot } from "react-dom/client";
import App from "./App"; // Notice: no .tsx extension
import "./index.css";    // This imports your Tailwind/Shadcn styles
import "./styles/zamwheelz.css"; // Your custom styles

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);